import axios from 'axios';

const API = {};

const baseURL = process.env.VUE_APP_SERVICE_API_BASE_URL;
const merchantDataURL = process.env.VUE_APP_SERVICE_API_MERCHANT_INFO_URL;
axios.defaults.timeout = process.env.VUE_APP_API_TIMEOUT;

const axiosSpotley = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

const getUserToken = () => localStorage.getItem('user-token');
const setRequestAuthenticationToken = (config) => {
  const configuration = config;
  const token = getUserToken();
  if (token) {
    configuration.headers.authorization = `Bearer ${token}`;
  } else {
    delete configuration.headers.authorization;
  }
  return configuration;
};

axiosSpotley.interceptors.request.use(
  (config) => {
    const newConfig = setRequestAuthenticationToken(config);
    return newConfig;
  },
  error => Promise.reject(error),
);

API.createUser = user => axios.post(`${baseURL}/register`, user);

API.loginUser = user => axios.post(`${baseURL}/auth/login`, user);

API.sendFetchRevConnectionToken = token => axiosSpotley.get(`${baseURL}/auth/token?code=${token}`);

API.getConsumerData = () => axiosSpotley.get(`${baseURL}/getconsumers?business-id=1`);

API.postMerchantData = form => axiosSpotley.post(merchantDataURL, form, {
  filemime: 'multipart/form-data',
});

API.getLandingPageSettings = () => axiosSpotley.get(merchantDataURL);

export default API;
